import { FAQ_API_PATH } from 'constants/apiPaths';
import useAxios, { AxiosState } from 'hooks/useAxios';
import { FAQContentBase } from '../types/Faq';

export const useFaqContent = (): AxiosState<FAQContentBase> =>
  useAxios<FAQContentBase>(FAQ_API_PATH);
